import { Form, Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import Select from "../../../../components/common/inputs/Select";
import Input from "../../../../components/common/inputs/Input";
import UserModal from "../../../../components/common/modals/user-modal/UserModal";
import Button from "../../../../components/common/button/Button";
import { postApi } from "../../../../services/api/globalApi";
import {
  successMessage,
  warningMessage,
} from "../../../../utils/toastify-message/ToastifyMessage";
import { userSpecialValidation } from "../../../../utils/validations/discount/userSpecialValidation";

function UserSpecialDiscount({ data }) {
  const [users, setUsers] = useState([]);
  const [specialDiscount, setSpesialDiscount] = useState([]);
  const [singleSpecialDiscount, setSingleSpecialDiscount] = useState(null);
  const userModalRef = useRef();

  useEffect(() => {
    if (data?.length) {
      setSpesialDiscount(data);
    }
  }, [data]);

  const handleUser = (data) => {
    let newUser = users.filter((item) => {
      return item.mobile == data?.mobile;
    });
    if (newUser.length) {
      warningMessage("شما این کاربر را قبلا اضافه کرده اید.");
    } else {
      setUsers((prev) => [...prev, data]);
      successMessage("کاربر با موفقیت به لیست اضافه شد.");
    }
  };

  const formHandler = (values, { resetForm }) => {
    values["isActive"] = values.isActive == "true" ? true : false;
    if (users.length) {
      if (singleSpecialDiscount) {
        let newDiscounts = [...specialDiscount];
        newDiscounts.splice(discountIndex, 1);
        const data = {
          ...values,
          users: users,
        };
        setSpesialDiscount([...newDiscounts, data]);
        reset();
      } else {
        const data = {
          ...values,
          users: users,
        };
        setSpesialDiscount((prev) => [...prev, data]);
        resetForm();
        reset();
      }
    } else {
      warningMessage("لطفا برای تخفیف خود کاربر انتخاب کنید.");
    }
  };

  const handle = async () => {
    const newSpesialDiscount = specialDiscount.map((item) => {
      let NewUser = item.users.map((item) => {
        {
          return item._id;
        }
      });
      return { ...item, users: NewUser };
    });
    console.log(newSpesialDiscount);
    const path = "admin/discounts";
    const body = {
      userSpecialDiscount: newSpesialDiscount,
    };
    try {
      const data = await postApi({ path, body });
      console.log(data);
      successMessage("تخفیف با موفقیت بروزرسانی شد.");
    } catch (error) {
      console.log(error);
    }
  };

  const [discountIndex, setDiscountIndex] = useState(null);

  const editDiscount = ({ item, index }) => {
    console.log(item);
    setDiscountIndex(index);
    setSingleSpecialDiscount({
      ...item,
      isActive: item.isActive ? "true" : "false",
    });
    setUsers(item?.users);
  };

  const deleteUser = (data) => {
    let newUser = users.filter((item) => {
      return item.mobile !== data.mobile;
    });
    setUsers(newUser);
  };

  const deleteDiscount = (index) => {
    let newDiscounts = [...specialDiscount];
    newDiscounts.splice(index, 1);
    setSpesialDiscount(newDiscounts);
  };

  const reset = () => {
    setUsers([]);
    setSingleSpecialDiscount(null);
    setDiscountIndex(null);
  };

  return (
    <div className="w-full py-4 px-4 border-r border-l">
      <div className="grid gap-6 mb-4">
        <Formik
          enableReinitialize
          initialValues={{
            percent: singleSpecialDiscount?.percent || "",
            isActive: singleSpecialDiscount?.isActive || "true",
          }}
          validationSchema={userSpecialValidation}
          onSubmit={formHandler}
        >
          <Form>
            <div className="grid gap-6 mb-4 md:grid-cols-2">
              <Input
                name="percent"
                placeholder="درصد"
                label="درصد"
                type="text"
              />
              <Select
                name="isActive"
                placeholder="فعال باشه؟"
                label="فعال باشه؟"
              >
                <option value={"true"}>بله</option>
                <option value={"false"}>خیر</option>
              </Select>
            </div>

            <div className="mt-6">
              <Button
                type="button"
                onClick={() => userModalRef.current.showModal()}
                text={"افزودن کاربر"}
                color={"primary"}
              />
            </div>
            <h3 className="my-3 dark:text-white">لیست کاربران</h3>
            <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
              {users.length ? (
                <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                  <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                    <tr>
                      <th scope="col" className="px-6 py-3">
                        نام
                      </th>
                      <th scope="col" className="px-6 py-3">
                        موبایل
                      </th>
                      <th scope="col" className="px-6 py-3">
                        عملیات
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {users.map((item) => {
                      return (
                        <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                          <th
                            scope="row"
                            className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                          >
                            {item.name}
                          </th>
                          <td className="px-6 py-4">{item.mobile}</td>
                          <td className="px-6 py-4 text-right">
                            <button
                              type="button"
                              onClick={() => deleteUser(item)}
                              className="font-medium text-red-600 dark:text-red-500 hover:underline"
                            >
                              حذف
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              ) : (
                <div className="w-full flex items-center justify-center my-3 py-2 dark:text-white">
                  <p>هیچ کاربری هنوز انتخاب نشده است.</p>
                </div>
              )}
            </div>

            <div className="flex flex-col gap-y-2">
              <div className="mt-6 flex items-center gap-2">
                <Button
                  text={singleSpecialDiscount ? "ویرایش تخفیف" : "افزودن تخفیف"}
                  color={"success"}
                />
                {singleSpecialDiscount && (
                  <Button
                    onClick={reset}
                    type="button"
                    text={"بازگشت"}
                    color={"danger"}
                  />
                )}
              </div>
            </div>
          </Form>
        </Formik>
      </div>

      <UserModal ref={userModalRef} handleUser={handleUser} />
      <h3 className="mb-3 dark:text-white">لیست تخفیفات</h3>
      <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
        {specialDiscount.length ? (
          <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="px-6 py-3">
                  درصد تخفیف
                </th>
                <th scope="col" className="px-6 py-3">
                  اکتیوه؟
                </th>
                <th scope="col" className="px-6 py-3">
                  تعداد کاربر ها
                </th>
                <th scope="col" className="px-6 py-3">
                  عملیات
                </th>
              </tr>
            </thead>
            <tbody>
              {specialDiscount.map((item, index) => {
                return (
                  <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                    <th
                      scope="row"
                      className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                    >
                      {item.percent}
                    </th>
                    <td className="px-6 py-4">
                      {item.isActive ? "بله" : "خیر"}
                    </td>
                    <td className="px-6 py-4">{item?.users?.length}</td>
                    <td className="px-6 py-4 text-right flex gap-2">
                      <button
                        onClick={() => editDiscount({ item, index })}
                        className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
                      >
                        نمایش و ویرایش
                      </button>
                      <button
                        onClick={() => deleteDiscount(index)}
                        className="font-medium text-red-600 dark:text-red-500 hover:underline"
                      >
                        حذف
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : (
          <div className="w-full flex items-center justify-center my-3 py-2 dark:text-white">
            <p>هیچ تخفیفی هنوز ایجاد نشده است.</p>
          </div>
        )}
      </div>
      <div className="flex flex-col gap-y-2">
        <div className="mt-6">
          <Button onClick={handle} text={"بروزرسانی تخفیف"} color={"success"} />
        </div>
      </div>
    </div>
  );
}

export default UserSpecialDiscount;
